<template>
	<!-- 底部 -->
	<div class="footer">
		<div class="bottom-footer">
			<div class="wp">
				<div class="copyright">
					<a target="_blank" href="./privacyPolicy.html">《隐私政策》</a>
					<p>服务热线：400-111-8166 (服务时间：8:00-21:30)</p><br/>
					<p>Copyright 2008-{{nowYear}}人民卫生出版社主办 <a target="_blank" href="https://beian.miit.gov.cn">京ICP备14053810号-2&nbsp;</a><a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502031110"><img class="footer-ghs" src="static/images/ghs.png"/>京公网安备 11010502031110号</a></p>
				</div>
			</div>
		</div>
	</div>
	<!-- 底部 end -->
</template>

<script>
	export default {
		name: "mFooter",
		data: () => {
			return {
				nowYear: ''
			}
		},
		created() {
			this.nowYear = new Date().getFullYear()
		},
		methods: {

		}
	}
</script>
<style scoped>
.clear-a-style:hover{
	color: #ffffff !important;
	text-decoration: none !important;
}
.footer-ghs {
	width: 20px;
	height: 20px;
	text-decoration: none;
	color: #fff;
	position: relative;
	top: -2px;
}
a:hover, a:focus{
	color: #fff;
}
.ul-footerNav .online{background:url(../../../static/images/f-icon08.png) no-repeat}
.ul-footerNav .Client{background:url(../../../static/images/f-icon09.png) no-repeat}
.ul-footerNav .WeChat{background:url(../../../static/images/f-icon010.png) no-repeat}
.ul-footerNav .Hotline{background:url(../../../static/images/f-icon011.png) no-repeat}
.fd-logo{width:37%;margin-bottom:20px;margin-top:0}
.fd-logo .ul-footerNav li{margin-left:0}
.fd-right{width:47%;margin-bottom:20px;margin-top:0}
.bottom-footer .wp{color: #eee; text-align: center; }
.footer .wp{overflow: hidden;}
.fd-right{text-align: left}
ol, ul{margin:0;padding:0}
.copyright p{color: #eee;}
</style>



// WEBPACK FOOTER //
// src/views/components/mFooter.vue